import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['No tenés tiempo', 'No sabés por dónde empezar', 'Probaste rutinas que no funcionan', 'Empezás… y dejás', 'Te sentís cansada antes de empezar'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto relative" data-id="element-235">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-red-50 blur-[120px] rounded-full pointer-events-none" data-id="element-236" />

      <div className="relative z-10" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-238">
          <span className="text-4xl mb-6 block" data-id="element-239">❓</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-8 leading-tight text-gray-900" data-id="element-240">
            ¿Cuántas veces más vas a empezar…{' '}
            <span className="text-gray-400" data-id="element-241">y abandonar?</span>
          </h2>

          <div className="space-y-4 text-xl md:text-2xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-242">
            <p data-id="element-243">Sos mamá.</p>
            <p data-id="element-244">
              Querés sentirte mejor. Querés volver a tu cuerpo. Querés tener
              energía.
            </p>
            <p className="text-gray-400 italic mt-8" data-id="element-245">
              Pero la realidad es otra:
            </p>
          </div>
        </motion.div>

        <div className="bg-white/80 border border-pink-200/50 rounded-3xl p-8 md:p-12 mb-16" data-id="element-246">
          <ul className="space-y-6 max-w-xl mx-auto" data-id="element-247">
            {painPoints.map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-4 text-lg md:text-xl text-gray-600" data-id="element-248">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-249">
                  <X size={20} className="text-brand-danger" data-id="element-250" />
                </div>
                <span data-id="element-251">{point}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6" data-id="element-252">
          <div className="inline-block bg-brand-card border border-pink-200 rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-253">
            <p className="text-xl md:text-2xl font-medium text-gray-600 mb-2" data-id="element-254">
              👉 No es falta de ganas.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-255">
              👉 Es falta de un{' '}
              <span className="text-brand-accent" data-id="element-256">sistema.</span>
            </p>
          </div>

          <p className="text-2xl md:text-3xl font-display font-bold text-gray-900 mt-16 pt-8 border-t border-pink-200/50" data-id="element-257">
            💥 ¿Y si este fuera el momento en que TODO cambia?
          </p>
        </motion.div>
      </div>
    </section>;
}